module.exports = __webpack_public_path__ + "img/x-icon-grey.3028f684.svg";